// import {
//     DashboardExerciseProgressRequestTimeframeEnum,
//     DashboardExerciseResponse,
//     DashboardExerciseSummary,
//     DashboardTimeframedRequest,
//     Exercise,
//     ExerciseCreateRequestGroupEnum,
//     HomeMuscleGroupRanking,
//     MostTrainedExercise,
//     Workout,
// } from '@api/entities';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import sessionStorage from 'redux-persist/lib/storage';
import { SelectableExerciseGroup } from 'src/features/exercise/utils/muscleGroups';
import { SelectableExercise } from './customer.slice';
import {
    DashboardExerciseProgress,
    DashboardExerciseProgressRequestTimeframeEnum,
    DashboardExerciseResponse,
    DashboardExerciseSummary,
    DashboardMostTrainedGroup,
    HomeMuscleGroupRanking,
    MostTrainedExercise,
    ProgramSession,
    ProgramSessionSet,
    Workout,
} from 'src/api/entities';
import { SelectableParameter } from 'src/features/exercise/utils/selectableParameters';
// import { SelectableExercise, SelectableExerciseGroup } from '@features/exercise/utils/muscleGroups';

export class CustomerExerciseFilter {
    group?: string;
    name?: MostTrainedExercise;
    timeframe?: DashboardExerciseProgressRequestTimeframeEnum;
    selectedParameter?: SelectableParameter;
}

export interface CustomerAnalysisState {
    trainedExercise: MostTrainedExercise;
    trainedExercises: MostTrainedExercise[];
    trainedGroups: SelectableExerciseGroup[];
    selectableExercises: SelectableExercise[];
    mostTrainedExercises: MostTrainedExercise[];
    trainedExerciseFilters: CustomerExerciseFilter;
    dashboardExerciseSummary: DashboardExerciseSummary;
    dashboardExerciseResponse: DashboardExerciseResponse;
    workoutHeadStatus: Workout;
    muscleGroupRanking: HomeMuscleGroupRanking;
    exerciseSets: ProgramSessionSet[];
    exerciseProgresses: DashboardExerciseProgress[];
    dashboardWorkoutExerciseSummary: DashboardExerciseSummary[];
    dashboardSessionExerciseSummary: DashboardExerciseSummary[];
}

const initialState: CustomerAnalysisState = {
    trainedExerciseFilters: {
        group: '',
        name: {
            exerciseGroup: '',
            exerciseName: '',
            exerciseUuid: '',
            frequency: 0,
        },
        timeframe: DashboardExerciseProgressRequestTimeframeEnum.Year,
        selectedParameter: {
            label: 'Weight',
            value: 'WEIGHT',
        },
    },
    trainedExercise: {},
    mostTrainedExercises: [],
    trainedGroups: [],
    selectableExercises: [],
    dashboardExerciseSummary: {},
    dashboardExerciseResponse: {},
    workoutHeadStatus: {},
    trainedExercises: [],
    muscleGroupRanking: {},
    exerciseSets: [],
    exerciseProgresses: [],
    dashboardSessionExerciseSummary: [],
    dashboardWorkoutExerciseSummary: []
};

export const customerAnalysisPersistedConfig = {
    key: 'customerAnalysis',
    storage: sessionStorage,
    whitelist: [
        'dashboardExerciseResponse',
        'selectableExercises',
        'dashboardExerciseSummary',
        'trainedExercise',
        'trainedExerciseFilters',
        'trainedExercises',
        'trainedGroups',
        'mostTrainedExercises',
        'workoutHeadStatus',
        'muscleGroupRanking',
        'exerciseSets',
        'exerciseProgresses',
        'dashboardSessionExerciseSummary',
        'dashboardWorkoutExerciseSummary'
    ],
};

export const customerAnalysisSlice = createSlice({
    name: 'customerAnalysis',
    initialState: initialState,
    reducers: {
        filterTrainedExerciseGroup(state, action: PayloadAction<{ selectedGroup: SelectableExerciseGroup }>) {
            state.trainedExerciseFilters.group = action.payload.selectedGroup.value;
            // state.trainedExercises = state.trainedExercises.filter(trainedExe => trainedExe.exerciseGroup == action.payload.selectedGroup.value);
            state.selectableExercises = [];
            state.trainedExercises
                .filter(exe => exe.exerciseGroup == action.payload.selectedGroup.value)
                .forEach(trainedExe => {
                    const selectable: SelectableExercise = {
                        label: trainedExe.exerciseName!,
                        value: trainedExe.exerciseUuid!,
                    };
                    console.log('Adding', selectable);
                    state.selectableExercises = [...state.selectableExercises, selectable];
                });
        },
        filterTrainedExerciseName(state, action: PayloadAction<{ value: MostTrainedExercise }>) {
            state.trainedExerciseFilters.name = action.payload.value;
        },
        filterTrainedExerciseTimeframe(state, action: PayloadAction<{ selectedTFM: DashboardExerciseProgressRequestTimeframeEnum }>) {
            state.trainedExerciseFilters.timeframe = action.payload.selectedTFM;
        },
        resetFilterTrainedExerciseGroup(state) {
            state.trainedExerciseFilters.group = '';
        },
        resetTrainedExerciseFilters(state) {
            state.trainedExerciseFilters = {
                group: undefined,
                name: undefined,
            };
        },
        setMostTrainedExercises(state, action: PayloadAction<{ value: MostTrainedExercise[] }>) {
            state.mostTrainedExercises = action.payload.value;
        },
        setExerciseSets(state, action: PayloadAction<{ value: ProgramSessionSet[] }>) {
            state.exerciseSets = action.payload.value;
        },
        resetExerciseSets(state) {
            state.exerciseSets = [];
        },
        resetMostTrainedExercises(state) {
            state.mostTrainedExercises = [];
            state.trainedGroups = [];
        },
        selectTimeframe(state, action: PayloadAction<{ value: DashboardExerciseProgressRequestTimeframeEnum }>) {
            state.trainedExerciseFilters.timeframe = action.payload.value;
        },
        selectParameter(state, action: PayloadAction<{ value: SelectableParameter }>) {
            state.trainedExerciseFilters.selectedParameter = action.payload.value;
        },
        reselectTimeframe(state) {
            state.trainedExerciseFilters.timeframe = DashboardExerciseProgressRequestTimeframeEnum.Year;
        },
        setTrainedExercisesItems(state, action: PayloadAction<{ value: MostTrainedExercise[] }>) {
            state.selectableExercises = [];

            state.trainedExercises = action.payload.value;
            state.trainedExercises.forEach(trainedExe => {
                const selectable: SelectableExercise = {
                    label: trainedExe.exerciseName!,
                    value: trainedExe.exerciseUuid!,
                };
                // console.log('Adding', selectable);
                state.selectableExercises = [...state.selectableExercises, selectable];
            });
            state.selectableExercises = state.selectableExercises.sort((a, b) => a.label.localeCompare(b.label));
        },
        setTrainedGroupItems(state, action: PayloadAction<{ groups: DashboardMostTrainedGroup[] }>) {
            state.trainedGroups = [];

            const trainedGroups = action.payload.groups.map(trainedExe => trainedExe.exerciseGroup);
            trainedGroups.forEach(group => {
                const selectableGroup: SelectableExerciseGroup = {
                    label: group!,
                    value: group!,
                };
                state.trainedGroups.push(selectableGroup);
            });
            state.trainedGroups = state.trainedGroups.sort((a, b) => a.label.localeCompare(b.label));
        },
        setTrainedExerciseItem(state, action: PayloadAction<{ value: MostTrainedExercise }>) {
            state.trainedExercise = action.payload.value;
        },
        setDashboardExerciseSummary(state, action: PayloadAction<{ value: DashboardExerciseSummary }>) {
            state.dashboardExerciseSummary = action.payload.value;
        },
        resetDashboardExerciseSummary(state) {
            state.dashboardExerciseSummary = {};
        },
        setDashboardExercise(state, action: PayloadAction<{ value: DashboardExerciseResponse }>) {
            state.dashboardExerciseResponse = action.payload.value;
        },
        setDashboard(state, action: PayloadAction<{ value: DashboardExerciseResponse }>) {
            state.dashboardExerciseResponse = action.payload.value;
        },
        setDashboardSessionExerciseSummary(state, action: PayloadAction<{ dashboardSessionExerciseSummaryResponse: DashboardExerciseSummary[] }>) {
            state.dashboardSessionExerciseSummary = action.payload.dashboardSessionExerciseSummaryResponse;
        },
        setDashboardWorkoutExerciseSummary(state, action: PayloadAction<{ dashboardSessionExerciseSummaryResponse: DashboardExerciseSummary[] }>) {
            state.dashboardWorkoutExerciseSummary = action.payload.dashboardSessionExerciseSummaryResponse;
        },
        resetDashboardExercise(state) {
            state.dashboardExerciseResponse = {};
        },
        setWorkoutHeadStatus(state, action: PayloadAction<{ value: Workout }>) {
            state.workoutHeadStatus = action.payload.value;
        },
        resetWorkoutHeadStatus(state) {
            state.workoutHeadStatus = {};
        },
        setMuscleGroupRanking(state, action: PayloadAction<{ value: HomeMuscleGroupRanking }>) {
            state.muscleGroupRanking = action.payload.value;
        },
        resetMuscleGroupRanking(state) {
            state.muscleGroupRanking = {};
        },
        resetTrainedExerciseItem(state) {
            state.trainedExercise = {};
        },
        setExerciseProgresses(state, action: PayloadAction<{ value: DashboardExerciseProgress[] }>) {
            state.exerciseProgresses = action.payload.value;
        },
        resetExerciseProgresses(state) {
            state.exerciseProgresses = [];
        },
    },
});

export const {
    setDashboardSessionExerciseSummary,
    setDashboardWorkoutExerciseSummary,
    setTrainedExercisesItems,
    setTrainedExerciseItem,
    resetTrainedExerciseItem,
    filterTrainedExerciseName,
    setTrainedGroupItems,
    filterTrainedExerciseGroup,
    filterTrainedExerciseTimeframe,
    resetFilterTrainedExerciseGroup,
    resetTrainedExerciseFilters,
    setDashboardExerciseSummary,
    selectParameter,
    resetDashboardExerciseSummary,
    setDashboardExercise,
    resetDashboardExercise,
    setWorkoutHeadStatus,
    resetWorkoutHeadStatus,
    setMuscleGroupRanking,
    resetMuscleGroupRanking,
    setExerciseSets,
    resetExerciseSets,
    setMostTrainedExercises,
    setExerciseProgresses,
    resetExerciseProgresses,
} = customerAnalysisSlice.actions;

export const customerAnalysisReducer = customerAnalysisSlice.reducer;
